import React, { useRef, useMemo,  useState } from 'react';
import { createMedsStep, medsCreateState } from 'store/storeValtio';
import { parseForm } from 'helpers/generalHelpers.js';

export default function MedicationWeekDays({ prevStep, nextStep }) {
  console.log('MedicationWeekDays', medsCreateState.schedule);
  const [nsChecked, setNsChecked] = useState(false);
  const [btnEnable, setBtnEnable] = useState(false);
  const [render, setRender] = useState(false);

  const weekdays = useRef([]);
  const checkedState = useRef([]);

  function refresh() {setRender(!render)};

  useMemo(() => {
    weekdays.current = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ];
    checkedState.current = new Array(weekdays.current.length).fill(false);

    // for each day of week
    const sched = medsCreateState.schedule;
    console.log('weekdays UM', sched);
    if (sched) {
      for (let i = 0; i < weekdays.current.length; ++i) {
        // for each schedule item
        sched.forEach((s) => {
          //console.log('sched', weekdays.current[i], s);
          if (s.includes(weekdays.current[i])) {
            checkedState.current[i] = true;
          }
        })
        let numChecked = numberChecked();
        (numChecked === medsCreateState.occurance) ? setBtnEnable(true) : setBtnEnable(false);
      }
    }
  },[]);

  function numberChecked() {
    let count = 0;
    checkedState.current.forEach( c => { if (c) ++count; })
    return count;
  }

  // not scheduled box
  function handleNSChange(e) {
    e.target.blur();
    console.log('nsChange', nsChecked);
    setNsChecked(!nsChecked);
    if (!nsChecked) {
      // if not scheduled, clear the weekday array
      checkedState.current = new Array(weekdays.current.length).fill(false);
      setBtnEnable(true);
    } else {
      setBtnEnable(false);
    }
  }

  function handleOnChange(e, dayNum) {
    //e.preventDefault();
    e.target.blur();
    console.log('change', e, dayNum);
    if (nsChecked) return;

    let numChecked = numberChecked();
    const isChecked = checkedState.current[dayNum];
    //console.log(checkedState.current, numChecked, isChecked);
    if (numChecked === medsCreateState.occurance && !isChecked) {
      // max number already checked, ignore
      return;
    }

    checkedState.current[dayNum] = isChecked ? false : true;
    numChecked = numberChecked();
    numChecked === medsCreateState.occurance ? setBtnEnable(true) : setBtnEnable(false);
    refresh();
  }

  function handleSubmit(e) {
    e.preventDefault();
    //console.log('submit', e);
    const formItems = e.target;
    //console.log('formItems', formItems);
    var formVals = parseForm(formItems);
    //console.log('formVals', formVals);
    //const password = formVals.password;
    let times = [];
    for (var key of Object.keys(formVals)) {
      if (formVals[key]) {
        //console.log( key, formVals[key] );
        times = [key, ...times];
      }
    }
    //console.log('times', times);
    medsCreateState.schedule = times;
    nextStep(createMedsStep.schedule);
  }

  return (
    <div className='flex flex-col'>
      <div className='medBody text-center'>
        On which {medsCreateState.occurance} days of the week<br/>do you take you medication?
      </div>
      <div className='mcard'>
        <form onSubmit={handleSubmit}>
          <div className='flex flex-col items-center justify-center'>
              <div className='w-40'>
                <ul>
                  {weekdays.current.map( (wd, i) => {
                      //console.log(wd, checkedState.current[i])
                      return (
                      <li key={i} className='w-30 p-0 m-0 text-start'>
                          <input 
                            key={i}
                            type='checkbox'
                            name={wd}
                            id={wd}
                            onChange={(e) => handleOnChange(e,i)}
                            checked={checkedState.current[i]}
                          />
                          <span className='pl-4 w-10'>{wd}</span>
                      </li>
                      )
                    })
                  }
                </ul>
              </div>
              <div className='w-40 pt-6 text-start'>
                <input 
                  type='checkbox'
                  name='NotScheduled'
                  id='NS'
                  onChange={(e) => handleNSChange(e)}
                  checked={nsChecked}
                />
                <span className='pl-4 w-10'>Not Scheduled</span>
              </div>
              <div className='pt-10'>
                <button
                    className='hpBtn'
                    disabled={!btnEnable}
                    type='submit'
                  >
                    Next
                </button>
              </div>          
          </div>
        </form>
      </div>
    </div>
  );
}
